export default __webpack_public_path__ + "static/media/ivana-square.b04026bd.jpg";